import initializeBasicAuth from 'nextjs-basic-auth'

const users = [{ user: 'admin', password: 'nagataku' }]

export default initializeBasicAuth({ users })
